import { render } from "./App.vue?vue&type=template&id=bd5cb94e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bd5cb94e&lang=scss"

import exportComponent from "/Users/champmar/Desktop/Outsource/seo-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__